import { StorageUsageResponse } from '@services/storage-usage/interfaces/storage-usage.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

export const STORAGE_USAGE_RESPONSE: StorageUsageResponse = {
  usedBytes: 3.5 * 1024 * 1024 * 1024,
  limitBytes: 15 * 1024 * 1024 * 1024,
  objectCount: 18240,
};

export const GET_STORAGE_USAGE_MOCK: Mock<StorageUsageResponse> = {
  success: [{ response: STORAGE_USAGE_RESPONSE }],
  failures: [],
};
